/* eslint-disable react-hooks/exhaustive-deps */
import Head from "next/head";
import { Tooltip } from "@src/common/components";
import React, { useEffect, useState } from "react";
import ShipmentsTable from "@src/shipments/components/ShipmentsTable";
import { useShipmentSelectionContext } from "@src/shipments/context/ShipmentSelectionContext";
import { useDispatchPreviewContext } from "@src/shipments/context/DispatchPreviewContext";
import { useCourieStore } from "@src/common/lib/store";
import { Sidebar } from "@src/common/components";
import { ordersPageWidgetsList } from "@src/shipments/utils/ordersPageWidgetsList";
import { useLocalStorage } from "usehooks-ts";
import { WidgetName } from "@src/common/components/Widgets/dashboardWidgetTypes";
import WidgetContainer from "@src/shipments/components/WidgetContainer/WidgetContainer";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import { useWidgetShortcuts } from "@src/common/hooks/useWidgetShortcuts";
import { Kbd } from "@src/common/components/Kbd/Kbd";

type Props = {};

function OrdersPage({}: Props) {
  // contexts
  const { setDispatchCandidatesWidgetSelectedItem } =
    useDispatchPreviewContext();
  const { selectedWidgetItem } = useCourieStore();
  const { selectedRow } = useShipmentSelectionContext();
  // states
  const parentRef = React.createRef<HTMLDivElement>();
  const [cursorWait, setCursorWait] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [lastSelectedWidgetOrdersPage, setLastSelectedWidgetOrdersPage] =
    useLocalStorage<WidgetName | undefined>(
      "lastSelectedWidgetOrdersPage",
      WidgetName.DISPATCH_CANDIDATES
    );
  const [isWidgetOpen, setIsWidgetOpen] = useState(true);

  useEffect(() => {
    if (isMounted === false) {
      setIsMounted(true);
    }
  }, []);

  useWidgetShortcuts({
    widgets: ordersPageWidgetsList,
    setSelectedWidget: setLastSelectedWidgetOrdersPage,
    setIsWidgetOpen,
    enabled: !!selectedRow,
  });

  useEffect(() => {
    if (selectedWidgetItem) {
      setDispatchCandidatesWidgetSelectedItem(selectedWidgetItem);
    }
  }, [selectedWidgetItem]);

  const cursorClass = cursorWait ? "cursor-wait" : "";

  return (
    <>
      <div
        className={`flex flex-col md:flex-row ${cursorClass}`}
        style={{ height: "calc(100vh - 56px)" }}
      >
        <div className="flex-1 overflow-y-auto relative" ref={parentRef}>
          <ShipmentsTable />
        </div>
        {selectedRow && (
          <>
            <Sidebar.Group className="px-0.5 h-full pb-2">
              {ordersPageWidgetsList.map((widgetItem: any, i: number) => {
                return (
                  <Tooltip
                    key={i}
                    content={
                      <span className="flex items-center gap-1.5">
                        {widgetItem.title}
                        <Kbd>{i + 1}</Kbd>
                      </span>
                    }
                    placement="left"
                  >
                    <Sidebar.Item
                      {...widgetItem}
                      active={
                        isWidgetOpen &&
                        widgetItem.name === lastSelectedWidgetOrdersPage
                      }
                      onClick={() => {
                        setLastSelectedWidgetOrdersPage(widgetItem.name);
                        setIsWidgetOpen(true);
                      }}
                    />
                  </Tooltip>
                );
              })}
              <div className="mt-auto">
                <Tooltip
                  content={
                    <span className="flex items-center gap-1.5">
                      {isWidgetOpen ? "Hide" : "Show"} widget
                      <Kbd>\</Kbd>
                    </span>
                  }
                  placement="left"
                >
                  <Sidebar.Item
                    icon={
                      isWidgetOpen ? (
                        <ChevronRightIcon className="h-6 w-6" />
                      ) : (
                        <ChevronLeftIcon className="h-6 w-6" />
                      )
                    }
                    active={false}
                    onClick={() => setIsWidgetOpen((prev) => !prev)}
                  />
                </Tooltip>
              </div>
            </Sidebar.Group>
            {isWidgetOpen && (
              <div className="w-full md:w-1/4 mt-4 md:mt-0 h-full overflow-auto">
                <WidgetContainer
                  selectedWidget={lastSelectedWidgetOrdersPage}
                  setCusorWait={setCursorWait}
                />
              </div>
            )}
          </>
        )}
      </div>
      <Head>
        <title>Orders</title>
      </Head>
    </>
  );
}

export default OrdersPage;
